import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Zap, Gift, Trophy } from 'lucide-react';
import './GameRules.css';

const GameRules = () => {
  const { t } = useLanguage();

  const rules = [
    {
      icon: <Zap size={48} />,
      title: t('rules.crazyModes.title'),
      description: t('rules.crazyModes.description'),
      color: '#ffff00'
    },
    {
      icon: <Gift size={48} />,
      title: t('rules.bonuses.title'),
      description: t('rules.bonuses.description'),
      color: '#ff00ff'
    },
    {
      icon: <Trophy size={48} />,
      title: t('rules.levels.title'),
      description: t('rules.levels.description'),
      color: '#00ffff'
    }
  ];

  return (
    <section className="game-rules">
      <h2 className="section-title glow-text">{t('rules.title')}</h2>
      <div className="rules-grid">
        {rules.map((rule, index) => (
          <div 
            key={index} 
            className="rule-card pixel-border"
            style={{ '--card-color': rule.color }}
          >
            <div className="rule-icon" style={{ color: rule.color }}>
              {rule.icon}
            </div>
            <h3 className="rule-title">{rule.title}</h3>
            <p className="rule-description">{rule.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GameRules;